import plans from "./plans"; //live
//import plans from "./plans_sandbox"; //sandbox
import promotions from "./promotions"; //live

// appSettings.js
const appSettings = {
  WEBPURCHASE_API_URL:
    "https://license.digi-ants.com/api/Payment/V1/WebPurchase",
  //"https://license.digi-ants.com/api/Payment/V1/WebPurchase", //LIVE
  //"https://localhost:44329/api/Payment/V1/WebPurchase", //DEBUG

  PAYPAL_CLIENT_ID:
    "AW7qxSxT4AJYeaJjcvnDpaaaoDpKYBRnhuSgi6LOi45_lIGLpVJU4Mu2wDd6mWo5igOK_MzXwaSYdPq1", //LIVE
  // "AewEZoh7h3c8pLWMZ0DwGsD8SPQc5UJokFD-PBHonANcgwFD1sJvHIuAYtv3RA0ZiLv_Kxi79ytlC5Ia", //Sandbox
  // "AW7qxSxT4AJYeaJjcvnDpaaaoDpKYBRnhuSgi6LOi45_lIGLpVJU4Mu2wDd6mWo5igOK_MzXwaSYdPq1", //LIVE

  PRODUCT_PLANS: plans,
  PROMOTIONS: promotions,
};

export default appSettings;
